import { Controller } from "stimulus"
import morph from 'morphdom';
import Utility from 'classes/Utility';
import Events from 'classes/Events';
import MitreTable from "../utils/mitre-table";

const CheckboxOnStateSvg = `
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="t-pointer-events-none" data-sticky-checkbox-target="buttonSvg">
    <path d="M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z" fill="#2532D0" />
    <mask id="path-2-inside-1" fill="white">
      <rect width="18" height="18" rx="1" />
    </mask>
    <rect width="18" height="18" rx="1" stroke="#2532D0" strokeWidth="3" strokeLinejoin="round" mask="url(#path-2-inside-1)" />
    <path d="M14 5L7.125 11.8384L4 8.27672" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
`

const CheckboxOffStateSvg = `
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="t-pointer-events-none" data-sticky-checkbox-target="buttonSvg">
    <mask id="path-1-inside-1" fill="white">
      <rect width="18" height="18" rx="1" />
    </mask>
    <rect width="18" height="18" rx="1" stroke="#2532D0" strokeWidth="3" strokeLinejoin="round" mask="url(#path-1-inside-1)" />
  </svg>
`

class StickyCheckboxController extends Controller {
  static targets = [ 'buttonSvg' ]
  static values = {
    state: Boolean,
    tableKey: String,
    totalStickyRows: Number
  }
  static classes = ['disabledState']

  async connect() {
    try {
      const response = await Utility.getConfigData({
        type: 'current_user'
      });
      const { premium } = response.data;
      this.isPremium = premium;
    } catch (e) {
      this.isPremium = false;
    }
    this.registerListeners();
  }

  toggleState = e => {
    e.preventDefault();
    if (this.stateValue) {
      this.stateValue = false
    } else {
      this.stateValue = true
    }
    this.element.dispatchEvent(Events.successEvent)
  }

  registerListeners = () => {
    const mitreTable = MitreTable.getByTableKey(this.tableKeyValue);
    mitreTable.on('table-row-stickied', ({ rowsCount }) => {
      this.totalStickyRowsValue = rowsCount;
    });
  }

  stateValueChanged = () => {
    if (this.stateValue) {
      morph(this.buttonSvgTarget, CheckboxOnStateSvg)
    } else {
      morph(this.buttonSvgTarget, CheckboxOffStateSvg)
    }

    if (this.stateValue == false && this.initialRendering == undefined) {
      this.initialRendering = true;
    } else {
      this.element.dispatchEvent(Events.successEvent)
    }
  }

  totalStickyRowsValueChanged = () => {
    if (this.isPremium) {
      if (this.totalStickyRowsValue === 3 && !this.stateValue) {
        // Button state of checkboxes that are not checked and there are 3 rows stickied already
        this.element.disabled = true;
        this.element.classList.add(this.disabledStateClass)
      } else {
        this.element.disabled = false;
        this.element.classList.remove(this.disabledStateClass)
      }
    }
  }
}

export default StickyCheckboxController;
